/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import https from 'https';
import getConfig from '../../config';
import uuid from 'uuid';
class PredictionService {
	/**
	 * fetches the predicition data from the Intent Server.
	 * @returns object
	 */
	fetchPrediction(data) {
		return this._performPredictionRequest(data);
	}

	/*
	 **
	 **  P R I V A T E   M E T H O D S
	 **
	 */
	static instance: PredictionService;

	constructor() {
		if (!PredictionService.instance) {
			PredictionService.instance = this;
		}
		return PredictionService.instance;
	}

	/**
	 * Retrieves predicition data from the Intent Server .
	 * @param {bodyData} json body data
	 * @returns {Object} prediction request response object
	 */
	_performPredictionRequest(bodyData: Record<string, unknown>) {
		// console.log('appserver', getConfigLearn.APP_SERVER);
		return new Promise((resolve) => {
			const postData = JSON.stringify(bodyData);
			const request = https.request(
				{
					hostname: getConfig('INTENTS_SERVER'),
					path: '/v1/models',
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'x-api-key': getConfig('CLIENT_ID'),
						'x-request-id': uuid.v4(),
					},
				},
				(res) => {
					// if (res.headers && typeof res.headers['x-request-id'] !== 'undefined') {
					// 	SearchAnalytics.contextGuid = res.headers['x-request-id'];
					// }
					if (res.statusCode && res.statusCode >= 300) {
						// On error, it should show the error status code
						window.cchome.util.logger.error(
							'Prediction Service',
							'Problem with Prediction Data Service request',
							res,
						);
						const predictionError = new Error(`${res.statusCode}`);
						resolve(predictionError);
					}
					else {
						let data = '';
						// set the encoding to UTF8 to prevent decoding issues on certain browsers.
						res.setEncoding('utf8');
						res.on('data', chunk => (data += chunk));
						res.on('end', () => {
							// Success!
							try {
								resolve(JSON.parse(data));
							}
							catch (e) {
								resolve(data);
							}
						});
					}
				},
			);

			request.on('error', (err) => {
				// on error, display the search error message
				window.cchome.util.logger.error(
					'Prediction Service',
					'Problem with Prediction Data Service request',
					err.toString(),
				);
				const predictionError = new Error('_performPredictionRequest error');
				resolve(predictionError);
			});
			request.write(postData);
			request.end();
		});
	}
}

export default PredictionService;
